import { Res } from 'common/types/responses'
import { Req } from 'common/types/requests'
import { service } from 'common/service'
import { responses } from 'common/types/mock-data'

export const auditService = service
  .enhanceEndpoints({ addTagTypes: ['Audit'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAudit: builder.query<Res['audit'], Req['getAudit']>({
        providesTags: (res) => [{ id: res?.id, type: 'Audit' }],
        query: (query: Req['getAudit']) => ({
          url: `partners/riskaudits/${query.id}`,
        }),
      }),
      getAudits: builder.query<Res['audits'], Req['getAudits']>({
        providesTags: [{ id: 'LIST', type: 'Audit' }],
        query: () => ({
          url: `partners/riskaudits`,
        }),
      }),
      // END OF ENDPOINTS
    }),
  })

export async function getAudits(
  store: any,
  data: Req['getAudits'],
  options?: Parameters<typeof auditService.endpoints.getAudits.initiate>[1],
) {
  return store.dispatch(
    auditService.endpoints.getAudits.initiate(data, options),
  )
}
export async function getAudit(
  store: any,
  data: Req['getAudit'],
  options?: Parameters<typeof auditService.endpoints.getAudit.initiate>[1],
) {
  return store.dispatch(auditService.endpoints.getAudit.initiate(data, options))
}
// END OF FUNCTION_EXPORTS

export const {
  useGetAuditQuery,
  useGetAuditsQuery,
  // END OF EXPORTS
} = auditService

/* Usage examples:
const { data, isLoading } = useGetAuditsQuery({ id: 2 }, {}) //get hook
const [createAudits, { isLoading, data, isSuccess }] = useCreateAuditsMutation() //create hook
auditService.endpoints.getAudits.select({id: 2})(store.getState()) //access data from any function
*/
